import axios from "axios";

const { REACT_APP_API_BASE_URL } = process.env;

export const createPayment = (data) => {
  return axios.post(REACT_APP_API_BASE_URL + "/api/payments", data);
};
